<template>
  <div class="bottom_tab hidden-sm-and-up">
    <img alt="" src="../../assets/img/home/logo.png" style="width:40%;"/>
    <img alt="" src="../../assets/img/qr-hscz.922c1e6.png"/>
    <p>长按识别二维码，关注智能工业装备公众号</p>
    <div class="phone">
      <span>联系电话：0531-82899508</span>
    </div>
    <div class="banquan">
      Copyright ©2025 山东智能工业装备 . All Rights Reserved .
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2025153067号-1</a>
      <img src="@/assets/img/备案图标.png" style="width: 13px;height: 13px"/>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37011202002399" rel="noreferrer" target="_blank">鲁公网安备37011202002399号</a>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.bottom_tab {
  width: 100%;
  height: 390PX;
  display: flex;
  flex-direction: column;
  background: #112F50;
  justify-content: center;
  align-items: center;
  padding-bottom: 20PX;
  box-sizing: content-box;

  img {
    width: 30%;

    &:first-child {
      margin-bottom: 20PX;
    }
  }

  p {
    color: #fff;
    padding: 10PX 0;
    font-size: 13PX;
    margin-top: 10PX;
  }

  .phone {
    width: 70%;
    height: 40PX;
    background: #F69E33;
    text-align: center;
    line-height: 40PX;
    margin: 20PX 0;

    span {
      color: #fff;
      font-size: 14PX;
    }
  }

  .banquan {
    margin-top: 10PX;
    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
}
</style>